import { useState } from "react";
import { DownArrow } from "../svg";
import MinusButton from "@/components/minus-button";
import useNoInitialRenderEffect from "../../hooks/useNoInitialRenderEffect";
import FormWithValidation from "./form-w-validation";
import Checkbox from "../checkbox";
import { ITEM_CATEGORIES } from "@/lib/constants";

export default function ItemMobileView({
  itemIndex,
  packageIndex,
  itemObj,
  parcel,
  updatePackage,
  packingType,
  setItemValueUpdateCounter,
}) {
  const [quantity, setQuantity] = useState(itemObj.quantity ?? "");
  const [description, setDescription] = useState(itemObj.description ?? "");
  const [category, setCategory] = useState(itemObj.category ?? null);
  const [totalValue, setTotalValue] = useState(itemObj.totalValue ?? "");
  const [totalWeight, setTotalWeight] = useState(itemObj.totalWeight ?? "");

  const [isFragile, setIsFragile] = useState(itemObj.fragile ?? true);

  const updateItem = () => {
    const itemDetails = {
      quantity: quantity,
      description: description,
      category: category,
      totalValue: totalValue,
      totalWeight: totalWeight,
      fragile: isFragile,
    };
    updatePackage("item", itemDetails, packageIndex, itemIndex);
  };

  const updateValidFields = (field, value) => {
    updatePackage("item", { [field]: value }, packageIndex, itemIndex);
  };

  useNoInitialRenderEffect(
    () => updateItem(),
    [quantity, description, category, totalValue, totalWeight, isFragile]
  );

  useNoInitialRenderEffect(() => {
    if (itemObj.validTotalValue)
      setItemValueUpdateCounter(
        (itemValueUpdateCounter) => itemValueUpdateCounter + 1
      );
  }, [totalValue, itemObj.validTotalValue]);

  return (
    <div className="px-6">
      <div className="flex relative">
        <p className="font-semibold self-center">Item {itemIndex + 1}</p>
        {parcel.items.length > 1 ? (
          <MinusButton
            className="absolute -right-2.5 w-6 h-6"
            onClick={() =>
              updatePackage("removeItem", null, packageIndex, itemIndex)
            }
          />
        ) : null}
      </div>

      <div className="grid grid-cols-2 gap-x-4 mt-2.5">
        <div className="flex flex-col">
          <FormWithValidation
            label="Qty"
            id={`quantity-p${packageIndex}i${itemIndex}`}
            type="text"
            inputMode="numeric"
            category="number"
            state={quantity}
            setState={setQuantity}
            isValid={itemObj.validQuantity}
            setIsValid={(value) => updateValidFields("validQuantity", value)}
          />
        </div>
        <div className="flex flex-col">
          <label
            htmlFor={`category-i${itemIndex}`}
            className="font-normal text-subheading-gray w-max"
          >
            Category
          </label>
          <div
            className={`flex rounded-xl focus:outline-none ml-1 mt-1 h-[40px] relative ${
              !itemObj.validCategory
                ? "border-2 border-error-red rounded-lg"
                : "form-input"
            }`}
          >
            <select
              id={`category-p${packageIndex}i${itemIndex}`}
              className={`focus:outline-none rounded-xl appearance-none bg-transparent w-full h-full pl-3 ${
                !category ? "text-placeholder-gray" : ""
              }`}
              defaultValue={category ?? "none"}
              onBlur={(event) => {
                if (!event.target.value)
                  updateValidFields("validCategory", false);
                else updateValidFields("validCategory", true);
              }}
              onChange={(event) => setCategory(event.target.value)}
            >
              <option value="none" disabled>
                Category
              </option>
              {ITEM_CATEGORIES.map((category) => (
                <option
                  key={category.value}
                  value={category.value}
                  className="text-black"
                >
                  {category.text}
                </option>
              ))}
            </select>
            {!category ? (
              <DownArrow
                color="#844FFA"
                className="absolute right-4 top-[50%] -translate-y-[50%]"
              />
            ) : null}
          </div>
        </div>
      </div>

      <FormWithValidation
        label="Item Description"
        id={`description-p${packageIndex}i${itemIndex}`}
        category="item-description"
        maxLength={70}
        type="text"
        state={description}
        setState={setDescription}
        isValid={itemObj.validDescription}
        setIsValid={(value) => updateValidFields("validDescription", value)}
      />
      <div className="flex items-center gap-4">
        <FormWithValidation
          label="Total Value(S$)"
          id={`total-value-p${packageIndex}i${itemIndex}`}
          type="text"
          inputMode="decimal"
          category="float"
          state={totalValue}
          setState={setTotalValue}
          isValid={itemObj.validTotalValue}
          setIsValid={(value) => updateValidFields("validTotalValue", value)}
        />

        <FormWithValidation
          label="Total Weight(kg)"
          id={`total-weight-p${packageIndex}i${itemIndex}`}
          type="text"
          inputMode="decimal"
          category="float"
          state={totalWeight}
          setState={setTotalWeight}
          isValid={itemObj.validTotalWeight}
          setIsValid={(value) => updateValidFields("validTotalWeight", value)}
        />
      </div>
      {packingType === "Fragile" ? (
        <>
          <Checkbox
            id={`fragile-item-p${packageIndex}i${itemIndex}`}
            containerClassName="flex items-center mt-2 self-end"
            label="This item is fragile"
            checked={isFragile}
            onChange={() => setIsFragile(!isFragile)}
            className="w-4 h-4 mr-1"
          />
        </>
      ) : null}
    </div>
  );
}
